import React from "react";
import "../../styles/SalesFunnel.css";
import { Link } from "react-router-dom";
import Webservice from "../../Page-section/Webdevelopment/Webservice";
import Faq from "../../Page-section/Webdevelopment/Faq";
import Portfolio from "../../components/portfolio";

import {
  FaLightbulb,
  FaUsers,
  FaCode,
  FaCogs,
  FaAward,
  FaPaperPlane,
} from "react-icons/fa";

const Webprocess = () => {
  const points = [
    "Better user experience",
    "Higher search engine rankings",
    "Increased conversions",
    "Mobile-friendly design",
    "Faster loading speed",
  ];
  const point = [
    "Build a strong online presence",
    "Increase brand visibility",
    "Generate more leads",
    "Improve customer engagement",
    "Boost sales and revenue",
  ];

  const steps = [
    {
      id: 1,
      title: "Requirement Analysis",
      color: "green",

      icon: <FaLightbulb />,
      desc: "We understand your business objectives and target audience.",
    },
    {
      id: 2,
      title: "Planning & Strategy",
      color: "#0868a0",
      icon: <FaUsers />,
      desc: "We create a roadmap for your website development in noida project.",
    },
    {
      id: 3,
      title: "Design & Development",
      color: "green",
      icon: <FaCode />,
      desc: "Our team designs and develops a user-friendly website.",
    },
    {
      id: 4,
      title: "Design & Development",
      color: "#0868a0",
      icon: <FaCogs />,
      desc: "Our team designs and develops a user-friendly website.",
    },
    {
      id: 5,
      title: "Testing & Launch",
      color: "green",
      icon: <FaAward />,
      desc: "We thoroughly test the website before launching it.",
    },
    {
      id: 6,
      title: "Support & Maintenance",
      color: "#0868a0",
      icon: <FaPaperPlane />,
      desc: "As a trusted website designing Company in Noida, we provide ongoing support.",
    },
  ];
  return (
    <section className="sf-wrapper">
      <div className="sf-sidebar">
        <div className="sf-card">
          <h2>Our Services</h2>

          <ul className="sf-service-list">
            <li className="active">
              <Link to="/web-development-company-in-noida">
                Web Development
              </Link>
            </li>
            <li>
              <Link to="/web-design-services">Web Design</Link>
            </li>
            <li>
              <Link to="/seo-agency-noida">SEO Services</Link>
            </li>
            <li>
              <Link to="/content-marketing-services">Content Marketing</Link>
            </li>
            <li>
              <Link to="/social-media-marketing-services">
                Social Media Marketing
              </Link>
            </li>
            <li>
              <Link to="/ai-automation-services">AI Automation Services</Link>
            </li>

            <li>
              <Link to="/lead-generation-services">Lead Generation</Link>
            </li>
            <li>
              <Link to="/sales-funnel-optimization">
                Sales Funnel Optimization
              </Link>
            </li>
            <li>
              <Link to="/branding-agency-noida">Branding Services</Link>
            </li>
            <li>
              <Link to="/business-automation-services">
                Business Automation
              </Link>
            </li>
            <li>
              <Link to="/resources">Resources</Link>
            </li>
          </ul>
        </div>

        <div className="sf-card">
          <h2>Contact Info</h2>

          <div className="sf-contact">
            <p>Address :- Sector-62, Noida, India</p>
            <p>
              Phone :- <br />
              <a href="tel:+919315020291"> +91 9315020291</a>
            </p>
            <p>
              Email :- <br />
              <a href="mailto:connect@empowerweb.in">connect@empowerweb.in</a>
            </p>
          </div>
        </div>

        <Portfolio />
      </div>

      <div className="sf-main-content">
        <section className="why-container">
          <div className="why-content">
            <h2>Why Your Business Needs Professional Web Development</h2>

            <p>
              Your website is regularly the first interplay clients have along
              with your logo. A poorly designed site can drive visitors away,
              even as a nicely-optimized internet site can flip them into
              dependable customers. Partnering with a expert{" "}
              <b>web development in noida</b> carrier issuer guarantees that
              your internet site is rapid, stable, and optimized for search
              engines like google. Here are some key advantages:
            </p>

            <ul>
              {points.map((item, index) => (
                <li key={index}>
                  <span className="check">✔</span> {item}
                </li>
              ))}
            </ul>

            <p>
              Choosing the proper first-class net layout agency in noida can
              make a massive difference to your on line fulfillment.
            </p>
          </div>
        </section>
        <section className="freight-container">
          <div className="freight-content">
            <h3>Custom Web Development Solutions</h3>
            <p>
              Every commercial enterprise is specific, and your internet site
              must replicate that. Our web improvement in noida offerings are
              designed to fulfill your specific necessities and help you stand
              out inside the competitive market.
            </p>
            <div className="freight-boxes">
              <div className="box">
                <div>
                  <h4>Clean and modern design</h4>
                  <br />
                </div>
              </div>
              <div className="box">
                <div>
                  <h4>SEO-friendly structure</h4>
                </div>
              </div>
              <div className="box">
                <div>
                  <h4>Fast performance</h4>
                </div>
              </div>
            </div>
            <div className="freight-boxes">
              <div className="box">
                <div>
                  <h4>Easy navigation</h4>
                  <br />
                </div>
              </div>
              <div className="box">
                <div>
                  <h4>Secure coding practices</h4>
                </div>
              </div>
            </div>
            <br />
            <p>
              As one of the <b>top web development companies in noida</b>, we
              ensure that your website no longer only looks awesome however also
              performs extraordinarily well.
            </p>
          </div>
        </section>
        <Webservice />
        <section className="work-process-section">
          <h3 className="work-title">Our Web Development Process</h3>
          <p className="work-subtitle">
            We follow a structured approach to deliver the best results:
          </p>

          <div className="process-wrapper">
            {/* STEP LABELS */}
            <div className="process-line">
              {steps.map((step) => (
                <div
                  key={step.id}
                  className="process-step"
                  style={{ backgroundColor: step.color }}
                >
                  {step.title}
                </div>
              ))}
            </div>

            {/* STEP DETAILS */}
            <div className="process-grid">
              {steps.map((step) => (
                <div className="process-item" key={step.id}>
                  <div
                    className="process-iconv"
                    style={{ borderColor: step.color, color: step.color }}
                  >
                    {step.icon}
                  </div>
                  <h3 className="process-num" style={{ color: step.color }}>
                    {step.id.toString().padStart(2, "0")}
                  </h3>
                  <p className="process-text">{step.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
        <section className="why-container">
          <div className="why-content">
            <h2>How Our Services Help Your Business Grow</h2>

            <p>
              Partnering with a reliable Web Development Company in Noida can
              help you:
            </p>

            <ul>
              {point.map((item, index) => (
                <li key={index}>
                  <span className="check">✔</span> {item}
                </li>
              ))}
            </ul>

            <p>
              Our goal as a <b>best web design company in noida</b> is to help
              businesses succeed in the digital world.
            </p>
          </div>
        </section>
        <section className="benefits-section">
          <div className="container">
            <div className="header">
              <div className="title-row">
                <h3>What Makes Us the Best Choice?</h3>

                <p>
                  Choosing the right best web design company in noida is crucial
                  for your business success. Here’s why clients trust us:
                </p>
              </div>
            </div>

            <div className="cards">
              <div className="card">
                <h3>Experienced Team</h3>
              </div>
              <div className="card">
                <h3>Customized Approach</h3>
              </div>
              <div className="card">
                <h3>SEO-Friendly Development</h3>
              </div>
              <div className="card">
                <h3>Affordable Pricing</h3>
              </div>
              <div className="card">
                <h3>Timely Delivery</h3>
              </div>
            </div>
          </div>
        </section>
        <Faq />
        <section className="operations-wrapper">
          <div className="operations-left">
            <h3>Get Started with the Best Web Development Company</h3>
          </div>
          <div className="operations-right">
            <p>
              If you are looking for a trusted website designing Company in
              Noida, we are here to help. Our team is dedicated to delivering
              high-quality website development in noida solutions that meet your
              business needs.
            </p>
          </div>
        </section>
      </div>
    </section>
  );
};

export default Webprocess;
